import React from 'react';
import { Fragment } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { checkModules } from 'guards/CheckRoles';
import { RootState, useSelector } from '../../../redux/store';

function DeviceDetailsState(props: any) {
  const { refactoredDevice, device } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { workspace } = useSelector((state: RootState) => state.workspace);
  let capacidad = 0;
  device?.attributes.parameters.forEach((param: any) => {
    if (param.identifier === 'capacidad') capacidad = parseInt(param.value);
  });

  return (
    <div className="cuadro-redondeado" style={{ marginBottom: 20, marginRight: 0 }}>
      <h3>{t('deposit_state')}</h3>
      <div className="groups">
        <div className="group" style={{ marginRight: 0 }}>
          <div className="estados">
            <div className="bigCol">
              {refactoredDevice?.attributes.device_type_preset ===
              'preset:trackgas-flow-sensor-v1' ? (
                <label>{t('maximum_capacity')}</label>
              ) : (
                <label>{t('deposit_capacity')}</label>
              )}
              <div className="valor">
                {capacidad} {`${refactoredDevice?.unit}`}
              </div>
            </div>
          </div>
          <div className="estados">
            <div className="col">
              {refactoredDevice?.attributes.device_type_preset ===
              'preset:trackgas-flow-sensor-v1' ? (
                <label>{t('kilos')}</label>
              ) : (
                <label>{t('available_charge')}</label>
              )}
              <div className="valor_container">
                <span>
                  {Math.round(refactoredDevice?.volumen_aproximado)} {`${refactoredDevice?.unit}`}{' '}
                </span>

                <span
                  className="badge"
                  style={{
                    backgroundColor: refactoredDevice?.backgroundPercent,
                    color: `${
                      refactoredDevice?.backgroundPercent === 'rgb(222 68 68)' ? 'white' : 'black'
                    }`
                  }}
                >
                  {Math.round(((refactoredDevice?.percent ?? 0) * 10) / 10)}%
                </span>
              </div>
            </div>
            <div className="col">
              {refactoredDevice?.attributes.device_type_preset ===
              'preset:trackgas-flow-sensor-v1' ? (
                <label>{t('consumed_kilos')}</label>
              ) : (
                <label>{t('free_space')}</label>
              )}
              <div className="valor_container">
                <span className="valor">
                  {Math.round(refactoredDevice?.volumen_libre)} {`${refactoredDevice?.unit}`}{' '}
                </span>

                <span
                  className="badge"
                  style={{
                    backgroundColor: refactoredDevice?.backgroundPercent,
                    color: `${
                      refactoredDevice?.backgroundPercent === 'rgb(222 68 68)' ? 'white' : 'black'
                    }`
                  }}
                >
                  {' '}
                  {Math.round(100 - ((refactoredDevice?.percent ?? 0) * 10) / 10)}%
                </span>
              </div>
            </div>
          </div>
          <div
            className="estados"
            style={{
              opacity: '0.3'
            }}
          >
            <div className="col">
              <label>{t('daily_average_consum')}</label>
              <div className="valor">- {`${refactoredDevice?.unit}`}</div>
            </div>
            <div className="col">
              <label>{t('remaining_days')}</label>
              <div className="valor">- {t('days')}</div>
            </div>
          </div>
        </div>
      </div>

      {checkModules(workspace, ['orders']) ? (
        <Fragment>
          <hr className="linea" />
          <h3>{t('new_request')}</h3>
          <div className="groups" style={{ marginBottom: 0 }}>
            <div className="group">
              <div className="detail">
                {/* <label style={{ display: 'block' }}>Horario predeterminado</label> */}
                <Button
                  onClick={() => {
                    navigate(PATH_DASHBOARD.end_user.deliver.new);
                  }}
                  disabled={true}
                  style={{
                    // background: 'var(--navSectionBackground)',
                    background: 'gray',
                    color: 'white',
                    marginTop: 10,
                    maxWidth: 200,
                    whiteSpace: 'nowrap'
                  }}
                  variant={'contained'}
                >
                  {t('request_gasoil')}
                </Button>
              </div>
            </div>
          </div>
        </Fragment>
      ) : null}
    </div>
  );
}

export default DeviceDetailsState;
